<template>
  <div class="GrupoLojita">
    GrupoLojita
    <el-row :gutter="20">
      <el-col :lg="12" :sm="12" :xs="24">
        <el-select
            clearable
            v-model="modelData"
            style="width: 100%;"
            :allow-create="allowCreate"
            default-first-option
            filterable
            remote
            :remote-method="search"
            @change="change"
            :loading="loading">
          <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            <span style="float: left">{{ item.name }}</span>
          </el-option>
        </el-select>
      </el-col>
      <el-col :lg="12" :sm="12" :xs="24">
        <el-button v-if="modelData" style="height: 44px;" @click="openDialogEC">Associar</el-button>
      </el-col>
    </el-row>

    <el-dialog title="Criando Grupo de lojista" :visible.sync="dialogVisible">
      <div v-loading="loadingGru">
        <el-form-item prop="name" label="Nome">
          <el-input size="large" v-model="ruleForm.name" required />
        </el-form-item>
        <el-form-item prop="provider_id" label="Provider">
          <SearchProviders :model="ruleForm.provider_id" :isEdit="false" @handleValue="(x) => {$set(ruleForm, 'provider_id', x)}" />
        </el-form-item>
        <el-form-item v-if="showCNPJ" prop="cnpj" label="CNPJ">
          <div style="    margin-top: 23px;">
            <el-radio style="    height: 52px;" v-for="bus in listBussiness" :key="bus.id" v-model="ruleForm.cnpj" :label="bus.business_cnpj" border>
              <div style="display: flex;    flex-direction: column;    justify-content: center;    margin-left: 18px;    margin-top: -16px;">
                <strong>{{bus.business_name}}</strong>
                <span>{{bus.business_cnpj}}</span>
              </div>
            </el-radio>
          </div>
        </el-form-item>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancelar</el-button>
        <el-button type="primary" @click="createGrupoLojista">Criar</el-button>
      </span>
    </el-dialog>
    <el-dialog title="Associar Grupo lojista" :visible.sync="dialogVisibleEC">
      <div v-loading="loadingGruEC">
        <el-form-item prop="provider_id" label="Provider">
          <SearchProviders :model="ruleFormEc.provider_id" :isEdit="false" @handleValue="(x) => {$set(ruleFormEc, 'provider_id', x)}" />
        </el-form-item>
        <el-card shadow="never" style="height: 500px; overflow: auto">
          <span>Selecione os Estabelecimentos que deseja associar</span> <br> <br> <br>
          <TableSimple :multipleSelect="true" ref="tableECs" :list-data="listDataEcs" @paginationClick="paginationClick">
            <el-table-column prop="person.name_store" label="Nome da loja">
            </el-table-column>
            <el-table-column prop="person.name" label="Nome">
            </el-table-column>
          </TableSimple>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="float: left" @click="dialogVisible = false">Cancelar</el-button>
        <el-button type="primary" @click="associarGrupo">Associar</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
import {getLogista, postAssociarLogista, postLogista} from "@/app/domains/Config/services";
import {getErrorFilds, makeErrorFilds} from "@/app/plugins/utils";
import SearchProviders from "@/app/components/Providers/SearchProviders";
import {getEstaComercial} from "@/app/domains/Report/services";
import TableSimple from "@/app/components/Table/TableSimple";

export default {
  name: "GrupoLojita",
  components: {
    SearchProviders,
    TableSimple,
  },
  data () {
    return {
      loadingPage: false,
      loadingGru: false,
      loadingGruEC: false,
      allowCreate: false,
      dialogVisible: false,
      dialogVisibleEC: false,
      showCNPJ: false,
      loading: false,
      ruleForm: {
        name: '',
        provider_id: '',
      },
      ruleFormEc: {
        provider_id: '',
      },
      options: [],
      modelData: '',
      listDataEcs: {}
    }
  },
  props: ['listBussiness'],
  methods: {
    async associarGrupo (e) {
      this.loadingGruEC = true
      try {
        let idEcs = []
        this.$refs['tableECs'].$refs['tableSimple'].selection.map(x => {
          idEcs.push(x.id)
        })
        this.$set(this.ruleFormEc, 'department_store_ids', idEcs)
        this.$set(this.ruleFormEc, 'id', this.modelData)
        let response = await postAssociarLogista(this.ruleFormEc)
        
      } catch (e) {
        this.error = getErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingGruEC = false
      }
    },
    async openDialogEC () {
      this.dialogVisibleEC = true
      await this.listEstaComercial('?per_page=9999&marketplace_id='+this.$route.params.id)
    },
    paginationClick (arg) {
      this.listEstaComercial('?per_page=9999&marketplace_id='+this.$route.params.id+'&page='+arg.page)
    },
    async listEstaComercial (query = '') {
      this.loadingGruEC = true
      try {
        let response = await getEstaComercial(query)
        this.listDataEcs = response.data
      } catch (e) {
        this.error = getErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingGruEC = false
      }
    },
    async change (e) {
      
      if (this.allowCreate) {
        this.$confirm('Deseja criar um grupo com o nome ' + e + ' para esse Marketplace?', 'Atenção', {
          center: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          if (this.listBussiness.length !== 0) {
            this.showCNPJ = true
          }
          this.ruleForm.name = e
          this.dialogVisible = true
        }).catch(async () => {
          this.allowCreate = false
          await this.search('')
          this.modelData = ''
        });
      }
    },
    async search (query, edit = false) {
      try {
        let response = await getLogista('?name='+query)
        this.allowCreate = (response.data.data.length === 0)
        this.options = response.data.data
      } catch (e) {
        this.error = makeErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      }
    },
    async createGrupoLojista () {
      this.loadingGru = true
      try {
        this.$set(this.ruleForm, 'marketplace_id', this.$route.params.id)
        const response = await postLogista(this.ruleForm)
      } catch (e) {
        this.error = getErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingGru = false
      }
    }
  },
  mounted() {
    this.search('')
  }
}
</script>

<style scoped>

</style>
